import React from "react";
import { Box } from "@mui/material";
import { SECTION_LABELS } from "../AppointmentDetailsModal.constants";
import {
  StyledStatusLabel,
  StyledStatusChip,
} from "../AppointmentDetailsModal.styles";
import {
  getStatusChipProps,
  getPaymentStatusChipProps,
} from "../AppointmentDetailsModal.utils";

const AppointmentDetailsModalStatusSection = ({
  appointment,
  isPaid,
  isFreeConsultation,
  requiresPayment,
  isUpcomingSession = true,
}) => {
  const paymentChipProps = getPaymentStatusChipProps(isPaid, isFreeConsultation, requiresPayment, isUpcomingSession);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <StyledStatusLabel variant="caption">
          {SECTION_LABELS.APPOINTMENT_STATUS}
        </StyledStatusLabel>
        <StyledStatusChip
          {...getStatusChipProps(appointment.appointmentStatus, appointment.notes, isUpcomingSession)}
        />
      </Box>
      {paymentChipProps && (
        <Box>
          <StyledStatusLabel variant="caption">
            {SECTION_LABELS.PAYMENT_STATUS}
          </StyledStatusLabel>
          <StyledStatusChip {...paymentChipProps} />
        </Box>
      )}
    </Box>
  );
};

export default AppointmentDetailsModalStatusSection;
